import './Image.css'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { selectIsVbUploading, selectVbImage } from '../vb/reducer'
import UndoBackgroundButton from './UndoBackgroundButton'
import SetBackgroundButton from './SetBackgroundButton'
import ShareButton from './ShareButton'
import profileIcon from './profileIcon.png'
import { Badge } from '@zoom/react-ui'
import { proxyPexelsImageUrl } from '../util/pexels'

function Image({
  image,
  index,
  resultSelected,
  showAttribution = false,
  showSharing = false,
}) {
  const vbImage = useSelector(selectVbImage)
  const [imageLoaded, setImageLoaded] = useState(false)
  const isVbUploading = useSelector(selectIsVbUploading)
  const isCurrentAppliedImage = !isVbUploading && vbImage?.id === image.id

  const handleImageLoad = () => {
    // When the image is loaded, set imageLoaded to true and fade in using opacity
    setImageLoaded(true)
  }

  return (
    <div
      className={`SearchResult__image-container ${imageLoaded ? 'loaded' : ''}`}
    >
      <div className="SearchResult__image-screen screened" />
      <img
        alt={image.alt}
        className="SearchResult__image"
        src={proxyPexelsImageUrl(image.src.medium)}
        loading="lazy"
        decoding="async"
        onLoad={handleImageLoad}
        id={image.id}
      />
      <div className="screened">
        {showSharing && <ShareButton image={image} />}
      </div>
      {showAttribution && (
        <div
          className={`SearchResult__attribution screened ${
            isCurrentAppliedImage ? 'SearchResult__attribution-xs' : ''
          }`}
        >
          <img src={profileIcon} alt="profile icon" />
          <p>{image.photographer}</p>
        </div>
      )}
      {isCurrentAppliedImage ? (
        <>
          <div className="screened">
            <UndoBackgroundButton
              image={image}
              resultSelected={resultSelected}
              index={index}
            />
          </div>
          <Badge
            className="SearchResult__image-label"
            variant="label"
            content="CURRENT"
            labelColor="blue"
          />
        </>
      ) : (
        <div className="screened">
          <SetBackgroundButton
            image={image}
            resultSelected={resultSelected}
            index={index}
          />
        </div>
      )}
    </div>
  )
}

export default Image
